import ActiveTicketTypeSelect from './ActiveTicketTypeSelect'

export default ActiveTicketTypeSelect
